import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FragnetService, { Supplier } from 'services/FragnetService';

export const useSuppliers = () => {
  const { t } = useTranslation(['common', 'cart']);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  useEffect(() => {
    FragnetService.getSuppliers()
      .then((res) => setSuppliers(res))
      .catch((error: AxiosError) => {
        console.log(t('cart:suppliers_fetch_err'));
        console.error(error);
      });
  });

  return suppliers;
};

export default useSuppliers;
